import React from 'react';
//scss
import './Contact.scss';
//anime
import anime from 'animejs';
//icon
import Github from '../Icons/GithubFooter';
import LinkedIn from '../Icons/linkedInFooter';

class Contact extends React.Component {
  render() {
    return (
      <div className="Contact">
        <div className="Contact_liner">
          <div className="Contact_liner_Text">
            <div className="Contact_liner_Text_link">
              <a href="https://github.com/ThompsonHarris" target="_blank">
                <Github />
              </a>
              <a
                href="https://www.linkedin.com/in/thompson-harris-97a528189/"
                target="_blank"
              >
                <LinkedIn />
              </a>
            </div>
            <div className="Contact_liner_Text_bold">
              <a
                href="mailto:william.thompson.harris@gmail.com?Subject=Hi!"
                target="_top"
              >
                2022 ~ THOMPSON HARRIS
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
